// Note - delete this file when the filters are fetched from Backend
import { useState, useEffect } from 'react';
import { css } from 'styled-components';

import { useIsMobileDevice } from '@hivebrite/react-hooks';

import { FilterTypes } from 'hb-react/frontoffice/apps/Filters/constants/FilterTypes';

import useCustomTopicName from './useCustomTopicName';
import useTopicsMenuName from './useTopicsMenuName';
import { FULL_TEXT } from '../constants/nameFiltersTopic';

const useRealV0FiltersTopics = ({ categories, setCategoryView }) => {
  const isMobileDevice = useIsMobileDevice();

  const menuName = useTopicsMenuName();
  const topicName = useCustomTopicName();

  const fulltextFilter = {
    type: FilterTypes.SELECT_WITH_SEARCH_AND_OTHER_OPTIONS,
    name: FULL_TEXT,
    label: s__('Filters|Search for topics'),
    placeholder: s__('Filters|Search a name or keyword'),
    // we display the previous value like a placeholder to hint that any change will clear the filter
    showValueAsPlaceholder: true,
    noOptionsMessage: () =>
      s__('Filters|Search for a %{topicName}').i__({
        topicName,
      }),
    options: [
      {
        options: [
          {
            name: 'Search',
            id: 'search',
            type: 'search',
          },
        ],
        type: 'search',
        name: 'query[fulltext]',
      },
      {
        options: categories || [],
        renderLabel: (label) =>
          s__(
            'Filters|See %{customGroupName} in <strong>%{categoryName}</strong>',
          ).i__({
            customGroupName: menuName,
            categoryName: label,
          }),
        type: 'options',
        onChange: ({ data }) => {
          setCategoryView(data.id);
          // Remove focus from input on mobile to hide the keyboard
          if (isMobileDevice) {
            document.querySelector('#js-filter-app-form')?.focus();
          }
        },
        shouldUpdateFormikValues: false,
        name: 'query[category_id]',
      },
    ],
  };

  const locationFilter = {
    type: FilterTypes.LOCATION,
    name: 'current_location',
    label: s__('Filters|Search by location'),
    placeholder: s__('Filters|Type and select a location'),
    // this override is only temporary, until components have a unified style
    inputHtml: {
      inputHtml: {
        css: css`
          height: 36px;
        `,
      },
    },
  };

  const [realV0Filters, setRealV0Filters] = useState({
    top: [],
    overlay: [],
  });

  useEffect(() => {
    const newRealV0Filters = {
      ...realV0Filters,
      top: [
        {
          ...fulltextFilter,
          label: s__('Filters|Search for %{menuName}').i__({
            menuName,
          }),
        },
        locationFilter,
      ],
    };

    setRealV0Filters(newRealV0Filters);
  }, [menuName, categories]);

  return realV0Filters;
};

export default useRealV0FiltersTopics;
